<template>
  <div
    v-if="isInEditorMode"
    @click.stop="selectComponent(model)"
    @contextmenu="onShowContextMenu"
    :id="id" :class="{ 'dr-simple-container-editor-mode':isInEditorMode, 'dr-simple-layout-selected' : isSelected }"
  >
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="onDeleteComponent">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>
    <!-- режим корректировки -->
    <draggable v-if="isInEditorMode"
      :class="[ evaluateClasses({ classes: this.model.Class }), 'draggable-target-simple-layout']"
      :group="{ name:'container', put:['toolbox', 'container'] }"
      @add="onWidgetDraggableAdd"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :disabled="readonly"
      :list="model.Widgets"
    >

      <component v-for="widget in model.Widgets"
        :readonly='readonly'
        :key="widget.$ID"
        :is="widget.$Type"
        :parentsWidgets="currentListOfParentsWidgets"
        :model="widget"
        @modelChanged="onModelChanged"
        @deleteComponent="onDeleteWidget"
        @replaceComponent="onReplaceWidget"
      />

    </draggable>

    <!-- Контекстное меню -->
    <widgets-context-menu 
      v-if="isInEditorMode"
      v-model="showContextMenu" 
      :x="x" 
      :y="y"
      :snippetCreatable="!isInSnippetEditor"
      :widgetModel="model"
      @deleteComponent="onDeleteComponentFromContextMenu"
      @pasteCopiedWidget="onPasteCopiedWidget"
      @createSnippet="onCreateSnippet" 
    />
  </div>
  <!-- режим проигрывания -->
  <div v-else-if="isVisible" :class="evaluateClasses(classes)">
    <template v-for="widget in model.Widgets">
      <component
        :dataSource="dataSource"
        :parentDataWidget="parentDataWidget"
        @callDataSourceAction="$emit('callDataSourceAction', $event)"
        :key="widget.$ID"
        :is="widget.$Type"
        :model="widget"
      />
    </template>
  </div>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  mixins: [mixin, inputMixin, contextMenuMixin, widgetsWrapperMixin, jsonPatchMixin],
  computed: {
    id() {
      return this.model.$ID
    }
  },
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    // Удаление веррхних компонентов в simpleLayput
    onDeleteWidget(val) {
      this.model.Widgets = this.model.Widgets.filter(comp => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    onReplaceWidget({oldModel, newModel}) {
      this.model.Widgets = this.model.Widgets.map(x => {
        return x == oldModel ? newModel : x
      })
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(newModel)
    }
  }
}
</script>

<style lang="scss">
  .dr-simple-container-editor-mode{
    border:1px solid  #D3D3D3;
    min-height: 50px;
    padding: 10px;
    margin-top:10px;
    margin-bottom:10px;
  }
  .draggable-target-simple-layout{
    height: 100%;
    min-height: 100px;
  }
  .dr-simple-layout-selected {
    outline:2px solid #FFA500;
    outline-offset: -2px;
  }
</style>
